import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Tag,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { getApi } from "common/services/api";
import { HasAccess } from "../../../../common/utils/accessUtils";
import { getLoggedInUser, getEffectiveRoleName, isEmployee as checkIsEmployee } from "common/utils/roleUtils";
import CommonCheckTable from "common/components/checktable";
import EditTask from "../../components/jobProfile/editDepartment";
import { useLocation, useNavigate } from "react-router-dom";
import CommonDeleteModel from "common/components/commonDeleteModel";
import { deleteApi } from "common/services/api";
import { toast } from "react-toastify";
import viewIcon from "common/assets/img/viewIcon.png";
import editIcon from "common/assets/img/editIcon.png";
import { constant } from "common/constant";
import DateFormatter from "common/utils/dateFormater";
import { globalStyles } from "common/theme/styles";
import CustomStatus from "common/components/status/CustomStatus";
import { InterviewData } from "services/Recruit/data/interviewData";
import Rating from "services/Recruit/components/Rating/Rating";
import { candidateColums } from "services/Recruit/data/candidate";
import StatusProgress from "services/Recruit/components/StatusProgress/StatusProgress";
import { recruitConstant } from "services/Recruit/constant";
import deleteIcon from "common/assets/img/deleteIcon.png";
import { accessModuleTitles } from "common/constant";
import { API_PATHS } from "common/services/apiPaths";
import CustomStatusDropdown from "services/Recruit/components/AvailabilityDropdown";
import { jobStatusOptions } from "common/constant";
import { deleteManyApi } from "common/services/api";
import { useDispatch } from "react-redux";
import { updateCandidate } from "common/redux/reducers/candidateSlice";
import { getCandidateStageCounts } from "services/Crm/utils/calcUtils";
import { STAGE_DISPLAY_CONFIG } from "services/Crm/utils/calcUtils";
import { deleteMultipleCandidates } from "common/redux/reducers/candidateSlice";
import { downloadAttachment } from "common/redux/reducers/candidateSlice";
import { DownloadIcon } from "@chakra-ui/icons";
import { useBulkImport } from "common/hooks/useBulkImport";
import { BsUpload } from "react-icons/bs";
import BulkImportModal from "common/components/bulkImportModal/bulkImportModal";
import { candidateStatusOptions } from "common/constant";
import ActionMenu from "common/components/ActionMenu";
import {
  getTableFilters,
  saveTableFilters,
  clearTableFilters,
  getInitialFilterState
} from "common/utils/filterUtils";
import { formatNoticePeriod, formatStatusOrStage } from "common/utils/textFormatters";

const Candidates = () => {
  const title = recruitConstant.createCandidate;
  const TABLE_NAME = 'candidates'; // Define table name constant

  const [action, setAction] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [edit, setEdit] = useState(false);
  const loggedInUser = getLoggedInUser();
  const effectiveRoleName = getEffectiveRoleName(loggedInUser);
  const roleName = effectiveRoleName;
  const isEmployee = checkIsEmployee(loggedInUser);

  const [eventView, setEventView] = useState(false);
  const [id, setId] = useState("");
  const [selectedId, setSelectedId] = useState();
  const [selectedValues, setSelectedValues] = useState([]);
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [getTagValuesOutSide, setGetTagValuesOutside] = useState([]);
  const [searchboxOutside, setSearchboxOutside] = useState("");
  const [deleteMany, setDeleteMany] = useState(false);
  const [isImportLead, setIsImportLead] = useState(false);
  const [menuSelectedDeleteItem, setMenuSelectedDeleteItem] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [displaySearchData, setDisplaySearchData] = useState(false);
  const [searchedData, setSearchedData] = useState([]);
  const colors = globalStyles.colors;
  const candidateStageStyles = {
    new: { bg: "#F4F7FB", color: "#486581", borderColor: "#D9E2EC" },
    in_review: { bg: "#FFF8E8", color: "#B7791F", borderColor: "#F6E0A4" },
    available: { bg: "#EEF9F1", color: "#2F855A", borderColor: "#C6F0D5" },
    engaged: { bg: "#EEF4FF", color: "#3B5BDB", borderColor: "#D6E4FF" },
    offered: { bg: "#F6F0FF", color: "#6B46C1", borderColor: "#E4D7FF" },
    hired: { bg: "#EAFBF5", color: "#237A57", borderColor: "#C8EFD9" },
    rejected: { bg: "#FFF1F2", color: "#C05666", borderColor: "#F6D0D6" },
    sourced: { bg: "#F4F7FB", color: "#486581", borderColor: "#D9E2EC" },
    contacted: { bg: "#EEF4FF", color: "#3B5BDB", borderColor: "#D6E4FF" },
    screening: { bg: "#FFF8E8", color: "#B7791F", borderColor: "#F6E0A4" },
    interviewing: { bg: "#EEF9F1", color: "#2F855A", borderColor: "#C6F0D5" },
    withdrawn: { bg: "#F8FAFC", color: "#64748B", borderColor: "#E2E8F0" },
    onhold: { bg: "#FFF5F5", color: "#B45309", borderColor: "#F6D6AE" },
    pending: { bg: "#F8FAFC", color: "#64748B", borderColor: "#E2E8F0" },
  };
  const { bulkImportCandidates, isImporting } = useBulkImport();
  const [tableData, setTableData] = useState(() =>
    candidateColums.map((row, index) => ({
      ...row,
      id: row.id || index + 1,
      rating: typeof row.rating === "number" ? row.rating : 0,
    }))
  );
  const [permission] = HasAccess([accessModuleTitles.Candidates]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Redirect reviewers to document verification
  useEffect(() => {
    const user = (() => {
      try {
        const u = localStorage.getItem("user");
        return u ? JSON.parse(u) : null;
      } catch (e) {
        return null;
      }
    })();
    const userRole = user?.activeRoleId?.roleName || user?.role;
    if (userRole === "reviewer") {
      navigate("/recruitment/document-verification", { replace: true });
    }
  }, [navigate]);

  const location = useLocation();
  const state = location.state;

  // Initialize states with saved filters
  const [isCreatedByMeActive, setIsCreatedByMeActive] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.isCreatedByMeActive || false;
  });

  const [currentStatusFilter, setCurrentStatusFilter] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.currentStatusFilter || "";
  });

  const [dateFilter, setDateFilter] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.dateFilter || "";
  });

  const [customStartDate, setCustomStartDate] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.customStartDate || "";
  });

  const [customEndDate, setCustomEndDate] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.customEndDate || "";
  });

  const [selectedDate, setSelectedDate] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.selectedDate || "";
  });

  const [searchbox, setSearchbox] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.searchbox || null;
  });

  const [currentPage, setCurrentPage] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"));
    return paginationState?.pageName === title && paginationState?.currentPage
      ? paginationState.currentPage
      : 1;
  });

  const [pageSize, setPageSize] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"));
    return paginationState?.pageName === title && paginationState?.pageSize
      ? paginationState.pageSize
      : 10;
  });

  const [sortColumn, setSortColumn] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [finalSearchedData, setFinalSearchedData] = useState([]);
  const [metadata, setMetadata] = useState({});
  const [allStageData, setAllStageData] = useState([]);
  const [stageCounts, setStageCounts] = useState({
    Sourced: 0,
    Contacted: 0,
    Screening: 0,
    Interviewing: 0,
    Offered: 0,
    Hired: 0,
    Rejected: 0,
    Withdrawn: 0,
    OnHold: 0,
    Pending: 0,
  });

  // Save filters whenever they change
  useEffect(() => {
    const filters = {
      isCreatedByMeActive,
      currentStatusFilter,
      dateFilter,
      customStartDate,
      customEndDate,
      selectedDate,
      searchbox: searchbox || "",
    };
    saveTableFilters(TABLE_NAME, filters);
  }, [
    isCreatedByMeActive,
    currentStatusFilter,
    dateFilter,
    customStartDate,
    customEndDate,
    selectedDate,
    searchbox,
  ]);

  const handleDownloadAttachment = async (attachmentUrl, filename) => {
    try {
      await dispatch(downloadAttachment({ attachmentUrl, filename }));
    } catch (error) {
      console.error("Download attachment error:", error);
    }
  };

  const isSuperAdmin =
    loggedInUser?.role === "super_admin" || loggedInUser?.role === "superAdmin";

  const canSelectRow = useCallback(
    (rowData) => {
      const isCreator = rowData?.createBy?._id === loggedInUser?._id;
      return permission?.delete && (isSuperAdmin || isCreator);
    },
    [permission?.delete, isSuperAdmin, loggedInUser?._id]
  );

  const actionHeader = {
    Header: recruitConstant.actions,
    isSortable: false,
    center: true,
    cell: ({ row }) => {
      const isCreator = row?.original?.createBy?._id === loggedInUser?._id;
      const isOwner = row?.original?.owner?._id === loggedInUser?._id;
      const canDelete =
        permission?.delete && (isSuperAdmin || isCreator || isOwner);
      const canEdit =
        permission?.update && (isSuperAdmin || isCreator || isOwner);

      return (
        <ActionMenu
          canView={true}
          canEdit={canEdit}
          canDelete={canDelete}
          onView={() => {
            sessionStorage.setItem("mode", "overview");
            sessionStorage.setItem("returnToCandidates", "true"); // Add return flag
            navigate(`/recruitment/candidate-create/${row?.values?._id}`);
          }}
          onEdit={() => {
            sessionStorage.setItem("mode", "edit");
            sessionStorage.setItem("returnToCandidates", "true"); // Add return flag
            navigate(`/recruitment/candidate-create/${row?.values?._id}`);
          }}
          onDelete={() => {
            setSelectedValues([row?.values?._id]);
            setMenuSelectedDeleteItem([row?.values?._id]);
            setDeleteMany(true);
          }}
        />
      );
    },
  };

  const tableColumns = [
    {
      Header: "#",
      accessor: "_id",
      isSortable: false,
      width: 5,
    },
    {
      Header: recruitConstant.name,
      accessor: "name",
      cell: (cell) => {
        return (
          <Box display="flex" alignItems="center" gap={2}>
            <div className="link">
              <Text
                cursor="pointer"
                fontWeight="400"
                width={'100px'}
                onClick={() => {
                  sessionStorage.setItem("mode", "overview");
                  sessionStorage.setItem("returnToCandidates", "true"); // Add return flag
                  navigate(
                    `/recruitment/candidate-create/${cell?.row?.values?._id}`
                  );
                }}
                color={colors.cta["100"]}
                _hover={{ textDecoration: "underline" }}
              >
                {cell?.value}
              </Text>
            </div>
          </Box>
        );
      },
    },
    {
      Header: recruitConstant.candidateStage,
      accessor: "status",
      type: "text",
      cell: (cell) => {
        const normalizedStatus = String(cell?.value || "").toLowerCase().replace(/[-\s]/g, "_");
        const stageStyle = candidateStageStyles[normalizedStatus] || {
          bg: "#F8FAFC",
          color: "#64748B",
          borderColor: "#E2E8F0",
        };
        const stageLabel = candidateStatusOptions.find(
          (option) => option.value === cell?.value
        )?.label || formatStatusOrStage(cell?.value);

        return (
          <CustomStatus
            statusText={stageLabel}
            color={stageStyle.color}
          />
        );
      },
    },
    {
      Header: "Posting Title ",
      accessor: "currentJobTitle",
      cell: (cell) => {
        const formatJobTitle = (title) => {
          if (!title) return "-";
          return title
            .toString()
            .trim()
            .replace(/^Other[-\s]*/i, "")
            .replace(/[-_]+/g, " ")
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
        };

        const readableTitle = formatJobTitle(cell?.value);

        return (
          <Text
            fontWeight="500"
            fontSize="sm"
            color="gray.800"
          >
            {readableTitle}
          </Text>
        );
      },
    },
    {
      Header: "Score",
      accessor: "compatibilityScore",
      cell: (cell) => {
        const rowData = cell?.row?.original;
        const isCalculating = rowData?.compatibilityScoreStatus === 'calculating' && !cell?.value;

        return (
          <Text
            color={isCalculating ? "blue.500" : "inherit"}
            fontStyle={isCalculating ? "italic" : "normal"}
          >
            {isCalculating ? "Calculating..." : (cell?.value ?? "-")}
          </Text>
        );
      },
    },
    {
      Header: recruitConstant.experience,
      accessor: "experienceRange",
      type: "text",
      cell: (cell) => {
        const experienceValue = cell?.value;
        const experienceLabel =
          experienceValue === "0-1" ? "Year" : "Years";

        return (
          <Text
            fontSize="sm"
            fontWeight="700"
            whiteSpace="nowrap"
          >
            {experienceValue ? `${experienceValue} ${experienceLabel}` : "-"}
          </Text>
        );
      },
    },
     {
      Header: recruitConstant.noticePeriod,
      accessor: "noticePeriod",
      type: "text",
      cell: (cell) => (
        <Text
          fontSize="sm"
          fontWeight="700"
          whiteSpace="nowrap"
        >
          {formatNoticePeriod(cell?.value) || "-"}
        </Text>
      ),
    },
    {
      Header: recruitConstant.currentEmployer,
      accessor: "currentEmployer",
      type: "text",
      cell: (cell) => (
        <Text
          fontSize="sm"
          fontWeight="700"
        >
          {cell?.value || "-"}
        </Text>
      ),
    },
    {
      Header: recruitConstant.location,
      accessor: "city",
      type: "text",
      formikType: "text",
      cell: (cell) => {
        const city = cell?.row?.original?.city;
        const state = cell?.row?.original?.state;

        return (
          <Box>
            <Text
              fontSize="sm"
              fontWeight="700"
            >
              {city && state ? `${city}, ${state}` : "-"}
            </Text>
          </Box>
        );
      },
    },
    {
      Header: recruitConstant.recruiter,
      accessor: "owner",
      cell: (cell) => (
        <Box>
          <Text
            fontSize="sm"
            fontWeight="700"
          >
            {cell?.value?.firstName || cell?.value?.lastName
              ? `${cell?.value?.firstName || ""} ${cell?.value?.lastName || ""
                }`.trim()
              : constant.notAssigned}
          </Text>
        </Box>
      ),
    },
   
    {
      Header: recruitConstant.source,
      accessor: "source",
      type: "text",
      cell: (cell) => {
        return (
          <Box>
            <Text
              fontSize="sm"
              fontWeight="700"
            >
              {cell?.value
                ?.split("-")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")
                .replace("Other ", "") || constant.notAssigned}
            </Text>
          </Box>
        );
      },
    },
    {
      Header: recruitConstant.modifiedAt,
      accessor: "updatedAt",
      type: "text",
      cell: (cell) => (
        <Box>
          <Text
            me="10px"
            fontSize="sm"
            fontWeight="700"
          >
            <span>{DateFormatter(cell?.value)}</span>
          </Text>
        </Box>
      ),
    },
    ...(permission?.update || permission?.delete ? [actionHeader] : []),
  ];

  const fetchDataRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  const fetchVersionRef = useRef(0);
  const countsVersionRef = useRef(0);
  const filterValuesRef = useRef({
    currentPage,
    pageSize,
    sortColumn,
    sortOrder,
    searchbox,
    currentStatusFilter,
    isCreatedByMeActive,
    dateFilter,
    customStartDate,
    customEndDate,
    selectedDate,
    loggedInUserId: loggedInUser?._id
  });

  const formatLocalDate = useCallback((value) => {
    if (!value) return "";
    const date = value instanceof Date ? new Date(value) : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }, []);

  const getDateRange = (filter, customStart, customEnd, selected) => {
    let startDate = null;
    let endDate = null;

    if (filter) {
      if (filter === 'custom') {
        startDate = customStart;
        endDate = customEnd;
      } else if (selected) {
        startDate = selected;
        endDate = selected;
      } else {
        const now = new Date();
        switch (filter) {
          case 'today':
            startDate = formatLocalDate(now);
            endDate = formatLocalDate(now);
            break;
          case 'thisWeek':
            const startOfWeek = new Date(now);
            startOfWeek.setDate(now.getDate() - now.getDay());
            const endOfWeek = new Date(now);
            endOfWeek.setDate(now.getDate() + (6 - now.getDay()));
            startDate = formatLocalDate(startOfWeek);
            endDate = formatLocalDate(endOfWeek);
            break;
          case 'thisMonth':
            startDate = formatLocalDate(new Date(now.getFullYear(), now.getMonth(), 1));
            endDate = formatLocalDate(new Date(now.getFullYear(), now.getMonth() + 1, 0));
            break;
          case 'thisYear':
            startDate = formatLocalDate(new Date(now.getFullYear(), 0, 1));
            endDate = formatLocalDate(new Date(now.getFullYear(), 11, 31));
            break;
          default:
            break;
        }
      }
    } else if (selected) {
      startDate = selected;
      endDate = selected;
    }
    return { startDate, endDate };
  };

  const fetchData = async (
    page = currentPage,
    limit = pageSize,
    sortKey = sortColumn,
    order = sortOrder,
    searchTerm = "",
    fetchAllData = false,
    status = "",
    createBy = "",
    dateStart = null,
    dateEnd = null
  ) => {
    setIsLoading(true);

    let endpoint = `${API_PATHS.CANDIDATE_LIST}?page=${page}&limit=${limit}`;

    if (fetchAllData) {
      endpoint = `${API_PATHS.CANDIDATE_LIST}?allData=true`;
    }

    if (sortKey) {
      let sortParam;

      if (sortKey === "updatedAt") {
        sortParam = order === "desc" ? "-updatedAt" : "updatedAt";
      } else if (sortKey === "createdAt") {
        sortParam = order === "desc" ? "-createdAt" : "createdAt";
      } else {
        sortParam = order === "desc" ? `-${sortKey}` : sortKey;
      }

      endpoint += `&sort=${sortParam}`;
    }

    if (searchTerm) {
      endpoint += `&search=${encodeURIComponent(searchTerm)}`;
    }

    if (status) {
      endpoint += `&status=${encodeURIComponent(status.toLowerCase())}`;
    }

    if (createBy) {
      endpoint += `&createBy=${createBy}`;
    }

    if (dateStart) {
      endpoint += `&startDate=${dateStart}`;
    }

    if (dateEnd) {
      endpoint += `&endDate=${dateEnd}`;
    }

    const currentVersion = fetchAllData ? ++countsVersionRef.current : ++fetchVersionRef.current;

    try {
      const result = await getApi(endpoint);

      if (fetchAllData) {
        if (currentVersion !== countsVersionRef.current) return;
      } else {
        if (currentVersion !== fetchVersionRef.current) return;
      }

      if (fetchAllData) {
        setFinalSearchedData(result?.data?.data || []);
        setAllStageData(result?.data?.data || []);
      } else {
        setData(result?.data?.data || []);
        setMetadata(result?.data?.metadata);
      }
    } catch (e) {
      const isCurrent = fetchAllData ? currentVersion === countsVersionRef.current : currentVersion === fetchVersionRef.current;
      if (isCurrent) {
        toast.error(recruitConstant.errorMsg);
        console.error("Error fetching candidates:", e);
      }
    } finally {
      const isCurrent = fetchAllData ? currentVersion === countsVersionRef.current : currentVersion === fetchVersionRef.current;
      if (isCurrent) {
        setIsLoading(false);
      }
    }
  };

  fetchDataRef.current = fetchData;

  const handleSearchChange = (term) => {
    const trimmedTerm = term?.trim() || "";
    setSearchbox(trimmedTerm);

    const pageToFetch = trimmedTerm === "" ? currentPage : 1;
    if (trimmedTerm !== "" && currentPage !== 1) {
      setCurrentPage(1);
    }

    const createBy = isCreatedByMeActive ? loggedInUser?._id : "";
    const { startDate, endDate } = getDateRange(
      dateFilter,
      customStartDate,
      customEndDate,
      selectedDate
    );

    fetchData(
      pageToFetch,
      pageSize,
      sortColumn,
      sortOrder,
      trimmedTerm,
      false,
      currentStatusFilter,
      createBy,
      startDate,
      endDate
    );
  };

  const handleSortChange = (accessorKey) => {
    let newSortOrder = "asc";

    if (sortColumn === accessorKey) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    }

    setSortColumn(accessorKey);
    setSortOrder(newSortOrder);

    const createBy = isCreatedByMeActive ? loggedInUser?._id : "";
    const { startDate, endDate } = getDateRange(dateFilter, customStartDate, customEndDate, selectedDate);

    fetchData(
      currentPage,
      pageSize,
      accessorKey,
      newSortOrder,
      searchbox || "",
      false,
      currentStatusFilter,
      createBy,
      startDate,
      endDate
    );
  };

  const handleDeleteCandidate = async (ids) => {
    try {
      setDeleteMany(false);

      const result = await dispatch(deleteMultipleCandidates(ids));

      if (result.type.endsWith("/fulfilled")) {
        setSelectedValues([]);

        const createBy = isCreatedByMeActive ? loggedInUser?._id : "";
        const { startDate, endDate } = getDateRange(dateFilter, customStartDate, customEndDate, selectedDate);

        fetchData(
          currentPage,
          pageSize,
          sortColumn,
          sortOrder,
          searchbox || "",
          false,
          currentStatusFilter,
          createBy,
          startDate,
          endDate
        );

        const deletedIds = new Set(ids);
        setAllStageData((prevData) =>
          prevData.filter((candidate) => !deletedIds.has(candidate._id))
        );

        toast.success(
          `${menuSelectedDeleteItem.length > 0
            ? recruitConstant.candidate
            : selectedValues && selectedValues.length > 1
              ? `${recruitConstant.candidate}s`
              : recruitConstant.candidate
          } ${recruitConstant.deletedSuccessfully}`
        );

        setAction((pre) => !pre);
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setMenuSelectedDeleteItem([]);
    }
  };

  const recruiterDefaultHeaders = [
    recruitConstant.name,
    recruitConstant.candidateStage,
    "Posting Title ",
    "Score",
    recruitConstant.experience,
    recruitConstant.currentEmployer,
    recruitConstant.location,
    recruitConstant.recruiter,
    recruitConstant.noticePeriod,
  ];

  const [columns] = useState([...tableColumns]);
  const [selectedColumns, setSelectedColumns] = useState(() =>
    tableColumns
      .map((column) =>
        column?.Header === recruitConstant.compatibilityScore
          ? { ...column, Header: "Score" }
          : column
      )
      .filter(
        (column) =>
          column?.Header === "#" ||
          recruiterDefaultHeaders.includes(column?.Header) ||
          column?.Header === recruitConstant.actions
      )
  );

  const dataColumn = tableColumns?.filter((item) =>
    selectedColumns?.find(
      (column) =>
        (column?.accessor && column.accessor === item.accessor) ||
        column?.Header === item.Header ||
        (column?.Header === recruitConstant.compatibilityScore &&
          item.Header === "Score")
    )
  );

  // Restore filters on component mount or when returning from edit
  useEffect(() => {
    const isReturning = sessionStorage.getItem("returnToCandidates");
    const savedFilters = getTableFilters(TABLE_NAME);

    if (isReturning) {
      sessionStorage.removeItem("returnToCandidates");
    }

    if (savedFilters) {
      const createBy = savedFilters.isCreatedByMeActive ? loggedInUser?._id : "";
      const { startDate, endDate } = getDateRange(
        savedFilters.dateFilter,
        savedFilters.customStartDate,
        savedFilters.customEndDate,
        savedFilters.selectedDate
      );

      // Fetch paginated data with saved filters
      fetchData(
        currentPage,
        pageSize,
        sortColumn,
        sortOrder,
        savedFilters.searchbox || "",
        false,
        savedFilters.currentStatusFilter,
        createBy,
        startDate,
        endDate
      );
    } else {
      // Initial fetch without saved filters
      fetchData(currentPage, pageSize, sortColumn, sortOrder, "", false);
    }

    // Fetch all data for stage counts
    fetchData(1, 1000, null, null, "", true);
  }, []);

  useEffect(() => {
    if (allStageData && allStageData.length > 0) {
      const counts = getCandidateStageCounts(allStageData);
      setStageCounts(counts);
    }
  }, [allStageData]);

  useEffect(() => {
    filterValuesRef.current = {
      currentPage,
      pageSize,
      sortColumn,
      sortOrder,
      searchbox,
      currentStatusFilter,
      isCreatedByMeActive,
      dateFilter,
      customStartDate,
      customEndDate,
      selectedDate,
      loggedInUserId: loggedInUser?._id
    };
  }, [currentPage, pageSize, sortColumn, sortOrder, searchbox, currentStatusFilter, isCreatedByMeActive, dateFilter, customStartDate, customEndDate, selectedDate, loggedInUser?._id]);

  const hasCalculatingScores = useMemo(() => {
    return data.some(
      (candidate) => candidate.compatibilityScoreStatus === 'calculating'
    );
  }, [data]);

  useEffect(() => {
    if (!hasCalculatingScores) {
      return;
    }

    const pollInterval = setInterval(() => {
      if (fetchDataRef.current) {
        const filters = filterValuesRef.current;
        const createBy = filters.isCreatedByMeActive ? filters.loggedInUserId : "";
        const { startDate, endDate } = getDateRange(
          filters.dateFilter,
          filters.customStartDate,
          filters.customEndDate,
          filters.selectedDate
        );
        fetchDataRef.current(
          filters.currentPage,
          filters.pageSize,
          filters.sortColumn,
          filters.sortOrder,
          filters.searchbox || "",
          false,
          filters.currentStatusFilter,
          createBy,
          startDate,
          endDate
        );
      }
    }, 10000);

    return () => {
      clearInterval(pollInterval);
    };
  }, [hasCalculatingScores]);

  const statusOptionList = useMemo(() => {
    const summaryStatusValueMap = {
      Interviewing: "interview",
    };

    return Object.keys(stageCounts).map((key) => ({
      label: STAGE_DISPLAY_CONFIG[key]?.label,
      value: stageCounts[key],
      color: STAGE_DISPLAY_CONFIG[key]?.color,
      statusValue:
        summaryStatusValueMap[key] ||
        candidateStatusOptions.find(
          (option) =>
            option.label?.toLowerCase() === STAGE_DISPLAY_CONFIG[key]?.label?.toLowerCase()
        )?.value ||
        key?.toLowerCase(),
    }));
  }, [stageCounts]);

  const onLinkClick = (id) => {
    sessionStorage.setItem("mode", "overview");
    sessionStorage.setItem("returnToCandidates", "true"); // Add return flag
    navigate(`/recruitment/candidate-create/${id}`);
  };

  const handleBulkImport = async (candidatesData) => {
    const result = await bulkImportCandidates(candidatesData);

    if (fetchData) {
      const nextSortColumn = sortColumn || "createdAt";
      const nextSortOrder = sortOrder || "desc";
      const createBy = isCreatedByMeActive ? loggedInUser?._id : "";
      const { startDate, endDate } = getDateRange(dateFilter, customStartDate, customEndDate, selectedDate);

      setCurrentPage(1);
      localStorage.setItem(
        "paginationState",
        JSON.stringify({
          pageName: title,
          currentPage: 1,
          pageSize,
        })
      );

      fetchData(
        1,
        pageSize,
        nextSortColumn,
        nextSortOrder,
        searchbox || "",
        false,
        currentStatusFilter,
        createBy,
        startDate,
        endDate
      );
    }

    return result;
  };

  const handleCreatedByMe = useCallback(async () => {
    const newState = !isCreatedByMeActive;
    setIsCreatedByMeActive(newState);

    const createBy = newState ? loggedInUser?._id : "";
    const { startDate, endDate } = getDateRange(dateFilter, customStartDate, customEndDate, selectedDate);

    await fetchData(
      currentPage,
      pageSize,
      sortColumn,
      sortOrder,
      searchbox || "",
      false,
      currentStatusFilter,
      createBy,
      startDate,
      endDate
    );
  }, [
    isCreatedByMeActive,
    currentPage,
    pageSize,
    sortColumn,
    sortOrder,
    searchbox,
    currentStatusFilter,
    fetchData,
    dateFilter,
    customStartDate,
    customEndDate,
    selectedDate,
    loggedInUser?._id,
  ]);

  const handleDateFilterChange = useCallback(
    (selectedFilter) => {
      setDateFilter(selectedFilter);
      setSelectedDate("");
      setCurrentPage(1);

      const { startDate, endDate } = getDateRange(selectedFilter, customStartDate, customEndDate, "");

      const createBy = isCreatedByMeActive ? loggedInUser?._id : "";
      fetchData(
        1,
        pageSize,
        sortColumn,
        sortOrder,
        searchbox || "",
        false,
        currentStatusFilter,
        createBy,
        startDate,
        endDate
      );
    },
    [
      isCreatedByMeActive,
      loggedInUser?._id,
      pageSize,
      sortColumn,
      sortOrder,
      searchbox,
      currentStatusFilter,
      fetchData,
      customStartDate,
      customEndDate,
    ]
  );

  const handleCustomDateChange = useCallback(
    (start, end) => {
      setCustomStartDate(start);
      setCustomEndDate(end);

      if (dateFilter === 'custom') {
        setCurrentPage(1);
        const createBy = isCreatedByMeActive ? loggedInUser?._id : "";
        fetchData(
          1,
          pageSize,
          sortColumn,
          sortOrder,
          searchbox || "",
          false,
          currentStatusFilter,
          createBy,
          start,
          end
        );
      }
    },
    [
      dateFilter,
      isCreatedByMeActive,
      loggedInUser?._id,
      pageSize,
      sortColumn,
      sortOrder,
      searchbox,
      currentStatusFilter,
      fetchData,
    ]
  );

  // Updated to clear ALL filters
  const handleClearDateFilter = useCallback(() => {
    // Clear date filters
    setDateFilter("");
    setCustomStartDate("");
    setCustomEndDate("");
    setSelectedDate("");

    // Clear other filters
    setIsCreatedByMeActive(false);
    setCurrentStatusFilter("");
    setSearchbox("");

    // Clear from localStorage
    clearTableFilters(TABLE_NAME);

    setCurrentPage(1);
    fetchData(
      1,
      pageSize,
      sortColumn,
      sortOrder,
      "",
      false,
      "",
      "",
      null,
      null
    );
  }, [
    pageSize,
    sortColumn,
    sortOrder,
    fetchData,
  ]);

  const handleDateSelect = useCallback(
    (selectedDateValue) => {
      setSelectedDate(selectedDateValue);
      setDateFilter("");
      setCurrentPage(1);

      const createBy = isCreatedByMeActive ? loggedInUser?._id : "";
      fetchData(
        1,
        pageSize,
        sortColumn,
        sortOrder,
        searchbox || "",
        false,
        currentStatusFilter,
        createBy,
        selectedDateValue,
        selectedDateValue
      );
    },
    [
      isCreatedByMeActive,
      loggedInUser?._id,
      pageSize,
      sortColumn,
      sortOrder,
      searchbox,
      currentStatusFilter,
      fetchData,
    ]
  );

  const handleStatusFilterChange = useCallback(
    
    (selectedStatus) => {
      console.log('status>>>',selectedStatus)
      setCurrentStatusFilter(selectedStatus);
      setCurrentPage(1);

      const createBy = isCreatedByMeActive ? loggedInUser?._id : "";
      const { startDate, endDate } = getDateRange(dateFilter, customStartDate, customEndDate, selectedDate);

      fetchData(
        1,
        pageSize,
        sortColumn,
        sortOrder,
        searchbox || "",
        false,
        selectedStatus,
        createBy,
        startDate,
        endDate
      );
    },
    [
      isCreatedByMeActive,
      loggedInUser?._id,
      pageSize,
      sortColumn,
      sortOrder,
      searchbox,
      fetchData,
      dateFilter,
      customStartDate,
      customEndDate,
      selectedDate,
    ]
  );

  const handleSummaryStatusClick = useCallback(
    (status) => {
      if (!status?.statusValue) {
        return;
      }

      handleStatusFilterChange(status.statusValue);
    },
    [handleStatusFilterChange]
  );

  return (
    <div className="pt-75 overviewtable">
      <Text
        className="candidate-title"
        fontSize="16px"
        fontWeight="700"
        lineHeight="24px"
        fontStyle="normal"
        color={colors.pageTitleColor}
        mb="16px"
      >
        {constant.candidatesSummary}
      </Text>
      <StatusProgress
        stageCounts={stageCounts}
        statusOption={statusOptionList || []}
        onStatusClick={handleSummaryStatusClick}
      />

      <BulkImportModal
        isOpen={isOpen}
        onClose={onClose}
        onImport={handleBulkImport}
      />
      <CommonCheckTable
        bulkImport={true}
        title={title}
        showInlineTitle={true}
        checkBox={canSelectRow}
        isLoading={isLoading}
        columnData={columns}
        dataColumn={dataColumn}
        allData={data}
        tableData={data}
        setSearchDisplay={setDisplaySearchData}
        tableCustomFields={[]}
        onLinkClick={onLinkClick}
        access={permission}
        action={action}
        setAction={setAction}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        isOpen={isOpen}
        setCurrentPage={setCurrentPage}
        fetchData={fetchData}
        currentPage={currentPage}
        onClose={onClose}
        onOpen={onOpen}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        setDelete={setDeleteMany}
        searchboxOutside={searchboxOutside}
        setSearchboxOutside={setSearchboxOutside}
        sortOrder={sortOrder}
        searchbox={searchbox}
        handleSortChange={handleSortChange}
        handleSearchChange={handleSearchChange}
        setSearchbox={setSearchbox}
        finalSearchedData={finalSearchedData}
        metadata={metadata}
        setFinalSearchedData={setFinalSearchedData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        filterStatusOptions={candidateStatusOptions}
        statusFilter={true}
        showCreatedByMeFilter={!isEmployee}
        handleCreatedByMe={handleCreatedByMe}
        isCreatedByMeActive={isCreatedByMeActive}
        createdByMeLabel="My Candidates"
        handleStatusFilterChange={handleStatusFilterChange}
        sortColumn={sortColumn}
        currentStatusFilter={currentStatusFilter}
        createByFilter={isCreatedByMeActive ? loggedInUser?._id : ""}
        isDynamic={true}
        dateFilterProps={{
          dateFilter,
          customStartDate,
          customEndDate,
          selectedDate,
          onDateFilterChange: handleDateFilterChange,
          onCustomDateChange: handleCustomDateChange,
          onDateSelect: handleDateSelect,
          onClearDate: handleClearDateFilter,
          hasActiveFilters: !!(
            isCreatedByMeActive ||
            currentStatusFilter ||
            searchbox?.trim()
          ),
        }}
      />

      <CommonDeleteModel
        isOpen={deleteMany}
        onClose={() => setDeleteMany(false)}
        type={`${menuSelectedDeleteItem.length > 0
          ? recruitConstant.candidate
          : selectedValues && selectedValues.length > 1
            ? `${recruitConstant.candidate}s`
            : recruitConstant.candidate
          }`}
        handleDeleteData={handleDeleteCandidate}
        ids={selectedValues}
        onCancel={() => setSelectedValues([])}
      />
    </div>
  );
};

export default Candidates;
